module.exports = __webpack_public_path__ + "caregiver profile.svg?1d2207bbb5d33857d991e995d120803d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobileapp/caregiver profile.svg
// module id = 356
// module chunks = 0